import React from "react";
import { FaceID, Delete } from "../../assets/svgs";
import "./styles.scss";

const DialPad = ({ onNumberPress, onDeletePress }) => {
  return (
    <div dir="ltr" className="dial-pad-container">
      <div className="keypad">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, "face", 0, "delete"].map((item, index) => {
          return (
            <button
              key={index}
              className="key"
              onClick={() => {
                if (typeof item === "number") {
                  onNumberPress(item.toString());
                } else if (item === "delete") {
                  onDeletePress();
                }
              }}
            >
              {typeof item === "number" ? (
                <span className="key-text">{item}</span>
              ) : item === "face" ? (
                <img src={FaceID} alt="face-id" className="key-icon" />
              ) : (
                <img src={Delete} alt="face-id" className="key-icon" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default DialPad;
